import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function localizationsRoutes($stateProvider: StateProvider) {
    let localizationModule: { default: any; };
    $stateProvider
        .state({
            name: 'localizations',
            url: '/localizations?q&category',
            params: {q: {dynamic: true}, category: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => localizationModule.default,
            },
            lazyLoad: async () => {
                localizationModule = await import(/* webpackChunkName: "localizations" */ './KpLocalizationsPage.svelte');
                return null;
            }
        });
}